import staticStates from './staticStates'

const states = staticStates.reduce(
  (obj, cur) => ({ ...obj, [cur]: null }),
  {}
)

export default states
